import { AuthProvider } from './../../providers/auth/auth';
import { FoserviceProvider } from './../../providers/foservice/foservice';
import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
/**
 * Generated class for the CheckoutPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-checkout',
  templateUrl: 'checkout.html',
})
export class CheckoutPage {

  dash: any[] = [];
  loading: Loading;
  name = '';
  username = '';
  serverlocation = '';
  token = '';
  userid = '';
  loadeditems: Array<any>;

  constructor(public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider,
    private foservice: FoserviceProvider, private loadingCtrl: LoadingController, private global: GlobalProvider) {
      let info = this.auth.getUserInfo();
    this.name = info.name;
    this.username = info.username;
    this.serverlocation = info.serverlocation;
    this.userid = info.userid;
    this.token = info.token;
    this.loadData();
  }

  public loadData() {
    //this.showLoading()
    this.showLoading();

    this.foservice.loadCheckout(this.userid, this.token, this.serverlocation, this.global.ICNO)
    .then((data: any[]) => {
      this.loading.dismiss();
      this.dash = data;
      this.loadeditems = data;
      console.log(this.dash);
    });

  }
  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }
  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.loadData();
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }
  itemTapped(event, detail) {
    // this.navCtrl.push(DashboardDetailPage, {
    //   detail: detail
    // });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FoDeparturePage');
  }

  initializeItems() {
    this.dash = this.loadeditems;
  }
  getItems(ev: any) {
    // Reset dash back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the dash
    if (val && val.trim() != '') {
        //this.dash = this.dash.filter((item) => {
        //    return (item.toLowerCase().indexOf(val.toLowerCase()) > -1);
        //})

        //INFO HOW TO FILTER JSON OBJECT {}

        this.dash = this.loadeditems.filter((v) => {
            if (v.GuestName && val) {
                if (v.GuestName.toLowerCase().indexOf(val.toLowerCase()) > -1) {
                    return true;
                }
                if (v.roomNo) {
                    if (v.roomNo.toLowerCase().indexOf(val.toLowerCase()) > -1) {
                        return true;
                    }
                }
                if (v.FolioNo) {
                  if (v.FolioNo.toLowerCase().indexOf(val.toLowerCase()) > -1) {
                      return true;
                  }
                }

                return false;
            }
        });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/checkout/checkout.ts